import { NomineeInfoRowData } from '../../components/dashboard/makeNct/UpdateNominee/types';
import { SignupPayload } from './login';
import { ModeOfHolding, TaxStatus } from './portfolio';

export const SEND_EMAIL_OTP = 'SEND_EMAIL_OTP';
export const SEND_EMAIL_OTP_SUCCESS = 'SEND_EMAIL_OTP_SUCCESS';

export const SEND_SMS_OTP = 'SEND_SMS_OTP';
export const SEND_SMS_OTP_SUCCESS = 'SEND_SMS_OTP_SUCCESS';

export const PRE_LOGIN_TRANSMISSION = 'PRELOGIN_TRANSMISSION';
export const PRE_LOGIN_TRANSMISSION_SUCCESS = 'PRELOGIN_TRANSMISSION_SUCCESS';

export const UPDATE_EMAIL = 'UPDATE_EMAIL';
export const UPDATE_EMAIL_SUCCESS = 'UPDATE_EMAIL_SUCCESS';

export const VERIFY_CHANGE_EMAIL_OTP = 'VERIFY_CHANGE_EMAIL_OTP';
export const VERIFY_CHANGE_EMAIL_OTP_SUCCESS = 'VERIFY_CHANGE_EMAIL_OTP_SUCCESS';

export const UPDATE_MOBILE = 'UPDATE_MOBILE';
export const UPDATE_MOBILE_SUCCESS = 'UPDATE_MOBILE_SUCCESS';

export const UPDATE_DIVIDEND = 'UPDATE_DIVIDEND';
export const UPDATE_DIVIDEND_SUCCESS = 'UPDATE_DIVIDEND_SUCCESS';

export const FETCH_TRACK_STATUS = 'FETCH_TRACK_STATUS';
export const FETCH_TRACK_STATUS_SUCCESS = 'FETCH_TRACK_STATUS_SUCCESS';

export const FETCH_COMMERCIAL_TRACK_STATUS = 'FETCH_COMMERCIAL_TRACK_STATUS';
export const FETCH_COMMERCIAL_TRACK_STATUS_SUCCESS = 'FETCH_COMMERCIAL_TRACK_STATUS_SUCCESS';

export const UPDATE_NOMINEE = 'UPDATE_NOMINEE';
export const UPDATE_NOMINEE_SUCCESS = 'UPDATE_NOMINEE_SUCCESS';

export const FETCH_INVESTOR_DETAILS = 'FETCH_INVESTOR_DETAILS';
export const FETCH_INVESTOR_DETAILS_SUCCESS = 'FETCH_INVESTOR_DETAILS_SUCCESS';

export const CONSOLIDATION_FOLIO = 'CONSOLIDATION_FOLIO';
export const CONSOLIDATION_FOLIOS_SUCCESS = 'CONSOLIDATION_FOLIOS_SUCCESS';

export const UPDATE_DATA_ENTRY = 'UPDATE_DATA_ENTRY';
export const UPDATE_DATA_ENTRY_SUCCESS = 'UPDATE_DATA_ENTRY_SUCCESS';

export const UPDATE_TAX_STATUS = 'UPDATE_TAX_STATUS';
export const UPDATE_TAX_STATUS_SUCCESS = 'UPDATE_TAX_STATUS_SUCCESS';

export const MINOR_TO_MAJOR = 'MINOR_TO_MAJOR';
export const MINOR_TO_MAJOR_SUCCESS = 'MINOR_TO_MAJOR_SUCCESS';

export const UPDATE_IFSC = 'UPDATE_IFSC';
export const UPDATE_IFSC_SUCCESS = 'UPDATE_IFSC_SUCCESS';

export const UPDATE_BANK_DETAILS = 'UPDATE_BANK_DETAILS';
export const UPDATE_BANK_DETAILS_SUCCESS = 'UPDATE_BANK_DETAILS_SUCCESS';

export const UPDATE_MULTIPLE_BANKS = 'UPDATE_MULTIPLE_BANKS';
export const UPDATE_MULTIPLE_BANKS_SUCCESS = 'UPDATE_MULTIPLE_BANKS_SUCCESS';

export const GET_FATCA_DETAILS = 'GET_FATCA_DETAILS';
export const GET_FATCA_DETAILS_SUCCESS = 'GET_FATCA_DETAILS_SUCCESS';

export const UPDATE_FATCA_DETAILS = 'UPDATE_FATCA_DETAILS';
export const UPDATE_FATCA_DETAILS_SUCCESS = 'UPDATE_FATCA_DETAILS_SUCCESS';

export const FETCH_IFSC_DETAILS = 'FETCH_IFSC_DETAILS';
export const FETCH_IFSC_DETAILS_SUCCESS = 'FETCH_IFSC_DETAILS_SUCCESS';

export const FETCH_FORM_15_DETAILS = 'FETCH_FORM_15_DETAILS';
export const FETCH_FORM_15_DETAILS_SUCCESS = 'FETCH_FORM_15_DETAILS_SUCCESS';

export const UPDATE_PRELOGIN_PAN = 'UPDATE_PRELOGIN_PAN';
export const UPDATE_PRELOGIN_PAN_SUCCESS = 'UPDATE_PRELOGIN_PAN_SUCCESS';

export const UPDATE_FORM_15 = 'UPDATE_FORM_15';
export const UPDATE_FORM_15_SUCCESS = 'UPDATE_FORM_15_SUCCESS';


export const LOCK_UNLOCK_FOLIOS = 'LOCK_UNLOCK_FOLIOS';
export const LOCK_UNLOCK_FOLIOS_SUCCESS = 'LOCK_UNLOCK_FOLIOS_SUCCESS';

export const GET_AMC_LIST = 'GET_AMC_LIST';
export const GET_AMC_LIST_SUCCESS = 'GET_AMC_LIST_SUCCESS';

export const GET_ALL_SECURITY_QUESTIONS = 'GET_ALL_SECURITY_QUESTIONS';
export const GET_ALL_SECURITY_QUESTIONS_SUCCESS = 'GET_ALL_SECURITY_QUESTIONS_SUCCESS';

export const GET_ALL_SECURITY_QUESTIONS_ANSWERS = 'GET_ALL_SECURITY_QUESTIONS_ANSWERS';
export const GET_ALL_SECURITY_QUESTIONS_ANSWERS_SUCCESS =
    'GET_ALL_SECURITY_QUESTIONS_ANSWERS_SUCCESS';

export const UPDATE_SECURITY_QUESTIONS = 'UPDATE_SECURITY_QUESTIONS';
export const UPDATE_SECURITY_QUESTIONS_SUCCESS = 'UPDATE_SECURITY_QUESTIONS_SUCCESS';

export const GIVE_FEEDBACK = 'GIVE_FEEDBACK';
export const GIVE_FEEDBACK_SUCCESS = 'GIVE_FEEDBACK_SUCCESS';

export const DOWNLOAD_SUMMARY = 'DOWNLOAD_SUMMARY';
export const DOWNLOAD_SUMMARY_SUCCESS = 'DOWNLOAD_SUMMARY_SUCCESS';

export const GENERATE_DETAILED = 'GENERATE_DETAILED';
export const GENERATE_DETAILED_SUCCESS = 'GENERATE_DETAILED_SUCCESS';

export const DOWNLOAD_DETAILED = 'DOWNLOAD_DETAILED';
export const DOWNLOAD_DETAILED_SUCCESS = 'DOWNLOAD_DETAILED_SUCCESS';

export const FETCH_ALL_CAS_HISTORY = 'FETCH_ALL_CAS_HISTORY';
export const FETCH_ALL_CAS_HISTORY_SUCCESS = 'FETCH_ALL_CAS_HISTORY_SUCCESS';

export const FETCH_ALL_CGS_HISTORY = 'FETCH_ALL_CGS_HISTORY';
export const FETCH_ALL_CGS_HISTORY_SUCCESS = 'FETCH_ALL_CGS_HISTORY_SUCCESS';

export const GET_CGS_DETAIL = 'GET_CGS_DETAIL';
export const GET_CGS_DETAIL_SUCCESS = 'GET_CGS_DETAIL_SUCCESS';

export const GET_CGS_DOCUMENT = 'GET_CGS_DOCUMENT';
export const GET_CGS_DOCUMENT_SUCCESS = 'GET_CGS_DOCUMENT_SUCCESS';

export const SAVE_DISPLAY_NAME = 'SAVE_DISPLAY_NAME';
export const SAVE_DISPLAY_NAME_SUCCESS = 'SAVE_DISPLAY_NAME_SUCCESS';

export const SAVE_IMAGE_DATA = 'SAVE_IMAGE_DATA';

export const TRANSMISSION_UNITS = 'TRANSMISSION_UNITS';
export const TRANSMISSION_UNITS_SUCCESS = 'TRANSMISSION_UNITS_SUCCESS';

export const GET_CRM_DATA = 'GET_CRM_DATA';
export const GET_CRM_DATA_SUCCESS = 'GET_CRM_DATA_SUCCESS';

export type DOB = string | Date;
export type PINCODE = string | number;

export type ADDRESS = {
    line1: string;
    line2?: string;
    line3?: string;
    country: string;
    state: string;
    city?: string;
    pincode: PINCODE;
};

export type GUARDIAN = {
    dob: DOB;
    name: string;
    pan: string;
    relation: string;
};

export type NOMINEE = {
    dob: DOB;
    gender: string;
    address: ADDRESS;
    id: string;
    name: string;
    pan: string;
    percent: number;
    relation: string;
    guardian?: GUARDIAN;
};

export type BANK = {
    accountNo: string;
    accountType: string;
    branch: string;
    city: string;
    default: string;
    ifsc: string;
    micr: string;
    name: string;
    neftIfsc: string;
    pincode: PINCODE;
};

export type INVESTOR_OBJECT = {
    amc?: string;
    amcName?: string;
    folio: number | string;
    dob: DOB;
    address: ADDRESS;
    guardian: GUARDIAN;
    investorName: string;
    investorPan: string;
    investorPekrn: string;
    thirdHolder: string;
    thirdHolderPan: string;
    thirdHolderPekrn: string;
    secondHolder: string;
    secondHolderPan: string;
    secondHolderPekrn: string;
    matchFlag?: 'Y' | 'N' | null;
    mobile: string;
    kycStatus: string;
    emailRelationship: string;
    mobileRelationship: string;
    modeOfHolding: ModeOfHolding;
    nominees: NOMINEE[];
    occupation: string;
    taxStatus: TaxStatus;
    bank: BANK[];
    transactionSource: string;
    lienUnitsFlag: 'Y' | 'N';
    assetType?: string[];
    taxStatusLabel: string;
    nomineeStatus: 'Y' | 'N' | 'NA' | 'O';
};

export interface AMCGroupInvestorFunds extends INVESTOR_OBJECT {
    amc: string;
    amcName: string;
}

export type INVETSOR_DETAILS_RESPONSE = {
    amc: string;
    amcName: string;
    investorDetails: INVESTOR_OBJECT[];
};

export type Form15Response = {
    id: string;
    amc: string;
    pan?: string;
    amcName: string;
    regStatus: 'N' | 'Y';
    docType: '15H' | '15G';
    year: string;
    isDisabled?: boolean;
};

export interface SEND_PHONE_OTP_PAYLOAD extends SignupPayload { }
export type AMC_LIST_RESPONSE = {
    amc_code: string;
    amc_name: string;
    rta_code: string;
    last_updated_date_time: string;
};

export type CGS_HISTORY_DATA = {
    documentId: string;
    fromDate: string;
    requestCompletionDateTime: string;
    requestDateTime: string;
    requestStatus: string;
    toDate: string;
    isDownloading?: boolean;
};

export type CAS_HISTORY_DATA = {
    documentId: string;
    fromDate: string;
    requestCompletionDateTime: string;
    requestDateTime: string;
    requestStatus: string;
    toDate: string;
    isDownloading?: boolean;
};

export type ImageSaveType = {
    type: NCT_TYPE;
    data: any;
};

export type NCT_TYPE =
    | 'UNREGISTERED_FOLIOS'
    | 'BANK_MANDATE'
    | 'CHANGE_BANK'
    | 'CHANGE_TAX_STATUS'
    | 'MINOR_TO_MAJOR'
    | 'CHANGE_MOBILE'
    | 'CHANGE_EMAIL'
    | 'DEATH_CERTIFICATE';

export type CRM_DETAILS = {
    reqId: string;
    pan: string;
    mobile: string;
    pekrn: string;
    email: string;
    summary: { totalRequest: number; pending: number; inProgress: number; resolved: number };
    data: any;
};

export type CRM_SCHEME_DESCRIPTION = {
    scheme: string;
    requestMode: string;
    natureOfComplaint: string;
    issueCategory: string;
    resolutionResponse: string;
    issueDescription: string;
};
